<template>
  <div class="zongJian">
    <statistics v-loading="sLoading" :list="statistics" :data="sData"></statistics>

    <div class="card-row">
      <chart-table2 source="gcDb" title="工程服务待办列表" class="row-col space-item" height="300" />
      <chart-table2 source="workYc" title="异常服务请求列表" class="row-col space-item" height="300" />
    </div>

    <!-- <div class="m-title">统计全部弱电工程服务请求单</div> -->
    <div class="m-title">统计全部工程服务请求单</div>
    <div class="card-row" style="position: relative;">
      <select-range ref="ref-request" :show-time="false" :request-data="requestData" @range-change="changeRange" />

      <div class="row-col" style="flex: 3;">
        <chart-pie2 chart-id="zjPie1" source="zjServiceType" :request-type="requestType" />
      </div>
      <div class="row-col" style="flex: 5;">
        <chart-bar5 chart-id="zjBar1" source="zjServiceType" :request-type="requestType" />
      </div>
    </div>

    <div class="m-title">全部异常服务请求</div>
    <div class="card-row">
      <div class="row-col" style="flex: 3;">
        <chart-pie2 chart-id="zjPie2" source="zjUnusual" />
      </div>
      <div class="row-col" style="flex: 5;">
        <chart-bar5 chart-id="zjBar2" source="zjUnusual" />
      </div>
    </div>

    <div class="card-row">
      <!-- <chart-table3 title="统计全部弱电工程完工现场服务次数" class="row-col space-item" height="450" /> -->
      <chart-table3 title="统计全部工程完工现场服务次数" class="row-col space-item" height="400" />
    </div>
  </div>
</template>

<script>
import Statistics from './components/statistics'
import ChartPie2 from './components/ChartPie2'
import ChartBar5 from './components/ChartBar5'
import ChartTable2 from './components/ChartTable2'
import ChartTable3 from './components/ChartTable3'
import SelectRange from './components/SelectRange'

/**
 * 总监 看板
 */
export default {
  name: 'viewZongJian',
  components: { Statistics, ChartPie2, ChartBar5, ChartTable2, ChartTable3, SelectRange },
  data() {
    return {
      /** @type {import('./index.vue').IRoleId */
      roleId: 'zongJian',
      requestData: [],
      requestType: '',
      statistics: [
        { num: 0, field: 'ZSQ_WORK', tip: '总申请服务请求' },
        { num: 0, field: 'YWC_WORK', tip: '完成服务请求' },
        { num: 0, field: 'WWC_WORK', tip: '未完成服务请求' },
        { num: 0, field: 'WWC_SERVICE', tip: '未完成现场服务单' },
        { num: 0, field: 'YDD_SERVICE', tip: '已到达现场服务单' },
        // { num: 0, field: 'YC_WORK', tip: '异常服务请求' },
        { num: 0, field: 'YC_SERVICE', tip: '异常现场服务单' }
      ],
      sData: {},
      sLoading: false
    }
  },
  mounted: function() {
    this.getRequestType()
    this.getSData()
  },
  methods: {
    /**
     * 获取数据
     * @param {import('./components/SelectRange.vue').IRange} range 选择日期、品牌、工程师
     */
    changeRange: function(range) {
      if (range.type === 'request') {
        this.requestType = range.data.current
      }
    },
    getRequestType: function() {
      let condition = { 'DIC_PCODE:0': 41243 }
      this.api.queryList('DB_DICTIONARY', { p2: condition, p9: '' }, `${this.roleId}_requestType`).then(res => {
        let resData = (res.result || []).map(item => {
          return { label: item.DIC_NAME, value: item.DIC_CODE }
        })

        this.requestData = resData
        this.requestType = (resData[0] || {}).value
        this.$refs['ref-request'].setValue('request', this.requestType)
      })
    },
    getSData: function() {
      let condition = {},
        roleId = this.roleId
      this.sLoading = false
      this.api.queryList('YW_STATISTICS_ZONGJIAN', { p2: condition, p9: '' }, `${roleId}_statistics`).then(
        res => {
          this.sLoading = false
          let resData = res.result
          this.sData = resData[0] || {}
        },
        err => {
          this.sLoading = false
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/viewBoard/viewZongJian.vue